export default __webpack_public_path__ + "static/media/juego2_instrucciones.a98ee0bb.png";